/*************************
 * ZOOM
 *************************/
function toggleZoom() {
  const container = document.querySelector('.bottle_variant_image');
  if (!container || container.dataset.zoomBound) return;

  container.addEventListener('click', () => {
    container.classList.toggle('zoomed');
  });

  container.dataset.zoomBound = 'true';
}

/*************************
 * IMAGE HELPERS
 *************************/
function getActiveMasterDataImgSrc(element) {
  if (!element) return '';
  let masterDataValue = element.getAttribute('data-master') || '';
  return masterDataValue.replace('_{width}x.progressive', '');
}

/*************************
 * ENSURE ENGRAVING DIV (BOTTLES)
 *************************/
function ensureEngraveTextBottles(selectedFont = '') {
  const container = document.querySelector('.bottle_variant_image');
  if (!container) return null;

  let engraveDiv = container.querySelector('.engrave-text-bottles');

  if (!engraveDiv) {
    engraveDiv = document.createElement('div');
    engraveDiv.className = 'engrave-text-bottles';
    container.appendChild(engraveDiv);
  }

  engraveDiv.classList.remove('font-manrope', 'font-snell');
  if (selectedFont === 'Manrope') {
    engraveDiv.classList.add('font-manrope');
  } else if (selectedFont) {
    engraveDiv.classList.add('font-snell');
  }

  return engraveDiv;
}

/*************************
 * ADD / REPLACE IMAGE
 *************************/
function addOrReplaceImageInBottleVariant(imageUrl, selectedFont = '') {
  toggleZoom();

  const previewImage = document.querySelector('#preview_image_metafield');
  if (previewImage) {
    imageUrl = previewImage.getAttribute('data-master');
  }

  const container = document.querySelector('.bottle_variant_image');
  if (!container) return;

  let img = container.querySelector('img');

  if (img) {
    img.src = imageUrl;
    img.classList.add('bottle-variant-img'); // add class if already exists
  } else {
    img = document.createElement('img');
    img.src = imageUrl;
    img.alt = '';
    img.style.width = '100%';
    img.style.height = 'auto';
    img.classList.add('bottle-variant-img'); // add class on creation
    container.appendChild(img);
  }

  ensureEngraveTextBottles(selectedFont);
}


/*************************
 * BIND BOTTLE INPUT
 *************************/
function bindBottleEngravingInput(getSelectedFont) {
  const box = document.querySelector('.engrave_text_input_bottles');
  if (!box) return;

  const input = box.querySelector('input[type="text"]');
  if (!input) return;

  let maxChar = null;
  const validateData = box.getAttribute('data-validate');
  if (validateData) {
    const match = validateData.match(/maxchar:(\d+)/);
    if (match) maxChar = parseInt(match[1], 10);
  }

  if (maxChar) input.setAttribute('maxlength', maxChar);

  input.addEventListener('input', function () {
    let val = this.value.replace(/[^a-zA-Z\s]/g, '');
    if (maxChar) val = val.substring(0, maxChar);
    this.value = val;

    const engraveDiv = ensureEngraveTextBottles(getSelectedFont());
    if (engraveDiv) engraveDiv.textContent = val;
  });

  // Initial sync
  const engraveDiv = ensureEngraveTextBottles(getSelectedFont());
  if (engraveDiv) engraveDiv.textContent = input.value || '';
}

/*************************
 * INIT
 *************************/
window.addEventListener('load', function () {

  let selectedFont = '';
  const font_manrope = 'font-manrope';
  const font_snell = 'font-snell';

  /***** FONT OBSERVER *****/
  const fontTextElement = document.querySelector('#ymq-box .font-selector .ymq_option_text_span');
  const engraveInput = document.querySelector('.engrave_text_input_bottles input[name="ymq[Text]"]');

  if (fontTextElement && engraveInput) {
    const observer = new MutationObserver(() => {
      selectedFont = fontTextElement.textContent.trim();

      engraveInput.classList.remove(font_manrope, font_snell);
      engraveInput.classList.add(
        selectedFont === 'Manrope' ? font_manrope : font_snell
      );

      ensureEngraveTextBottles(selectedFont);
    });

    observer.observe(fontTextElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  /***** VARIANT IMAGE *****/
  const valueWrapper = document.querySelector(
    '.product-page .product-page-info .product-options__values-wrapper'
  );

  function updateVariantImage() {
    if (!valueWrapper) return;
    const active = valueWrapper.querySelector('.product-options__value.active');
    if (!active) return;

    const src = getActiveMasterDataImgSrc(active);
    addOrReplaceImageInBottleVariant(src, selectedFont);
  }

  updateVariantImage();

  if (valueWrapper) {
    valueWrapper.addEventListener('click', e => {
      if (e.target.closest('.product-options__value')) {
        setTimeout(updateVariantImage, 30);
      }
    });
  }

  /***** BOTTLE INPUT *****/
  bindBottleEngravingInput(() => selectedFont);

  /***** BAGS (SAFE) *****/
  const engravePreviewImage = document.querySelector('.engrave_preview_image');
  if (engravePreviewImage) {
    const engraveTextDiv = document.createElement('div');
    engraveTextDiv.classList.add('engrave-text');
    engravePreviewImage.appendChild(engraveTextDiv);

    const box = document.querySelector('.engrave_text_input');
    if (box) {
      const input = box.querySelector('input[type="text"]');
      if (input) {
        let maxChar = null;
        const validateData = box.getAttribute('data-validate');
        if (validateData) {
          const match = validateData.match(/maxchar:(\d+)/);
          if (match) maxChar = parseInt(match[1], 10);
        }

        input.style.textTransform = 'uppercase';
        if (maxChar) input.setAttribute('maxlength', maxChar);

        input.addEventListener('input', function () {
          let val = this.value.replace(/[^a-zA-Z\s]/g, '').toUpperCase();
          if (maxChar) val = val.substring(0, maxChar);
          this.value = val;
          engraveTextDiv.textContent = val;
        });
      }
    }
  }

});


